import React from 'react';
import { FaEnvelope, FaClock } from 'react-icons/fa';
// import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaPhoneAlt, FaEnvelope, FaCheckCircle, FaClock } from 'react-icons/fa';
import mainlogo from '../assets/main-logo.png';
import './Footer.css';
import { TempleStatusDisplay } from './TempleStatusPopup';

function Footer({ templeStatus }) {

  const templeSchedule = [
    { time: "04:10AM", label: "Samadhi Aarti" },
    { time: "04:30AM", label: "Mangal Aarti" },
    { time: "05:30AM", label: "Japa Class" },
    { time: "07:25AM", label: "Narshima Aarti" },
    { time: "07:30AM", label: "Darshan Aarti" },
    { time: "08:00AM", label: "Bhagvatam Class" },
    { time: "12:15PM", label: "Raj Bhoga" },
    { time: "04:00PM", label: "Dhupa Aarti" },
    { time: "06:45PM", label: "Tulsi Aarti" },
    { time: "09:00PM", label: "Shayana Aarti" },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section logo-section">
          <img className="footer-logo" src={mainlogo} alt="ISKCON Ujjain" />
          <p>
            Address: Hare Krishna Land, 33-37, Administrative Zone, Bharatpuri, Ujjain, Madhya Pradesh 456010          </p>
          {/* <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaYoutube /></a>
          </div> */}
        </div>

        <div className="footer-section">
          <h4>Timing</h4>
          <TempleStatusDisplay templeStatus={templeStatus} />



          <ul className="space-y-2">
  {templeSchedule.map((item, index) => (
    <li key={index} className="flex items-center gap-2 text-sm">
      <FaClock className="text-pink-600" />
      <span>{item.label} – {item.time}</span>
    </li>
  ))}
</ul>

        </div>
        {/* 
        <div className="footer-section">
          <h4>Our Services</h4>
          <ul>
            <li><FaCheckCircle /> Simple Living, High Thinking</li>
            <li><FaCheckCircle /> Srila Prabhupada Audiobooks</li>
            <li><FaCheckCircle /> Life Membership</li>
            <li><FaCheckCircle /> Community Service Centre</li>
            <li><FaCheckCircle /> Gomata Products</li>
            <li><FaCheckCircle /> Buy Books Online</li>
          </ul>
        </div> */}

        <div className="footer-section">
          <h4>Contact Us</h4>
          <ul>
            {/* <li><FaPhoneAlt /> +917618183108</li> */}
            <li><FaEnvelope /> info@iskconujjain.com</li>
          </ul>
        </div>
      </div>
      <hr />
      <div className="footer-bottom center">
        <p>©2025 ISKCON Ujjain. All rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
